import { FC } from 'react';

type Props = {
	className?: string;
};

const CalendarAddIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M14.799 2V3.59997M5.19922 2V3.59997'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.2383 18C6.01396 18 4.40179 18 3.40011 16.9171C2.39844 15.8342 2.39844 14.0913 2.39844 10.6056V10.1947C2.39844 6.70897 2.39844 4.96607 3.40011 3.88318C4.40179 2.80029 6.01396 2.80029 9.2383 2.80029H10.7583C13.9826 2.80029 15.5948 2.80029 16.5965 3.88318C17.5793 4.94574 17.5978 6.64372 17.5981 10.0001'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M2.79688 6.7998H17.1966'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M10.7969 14.7995H17.1967M13.9968 11.5996V17.9995'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default CalendarAddIcon;
